import { render } from "./storeSettings.vue?vue&type=template&id=2d2b4f6d&scoped=true&ts=true"
import script from "./storeSettings.vue?vue&type=script&lang=ts"
export * from "./storeSettings.vue?vue&type=script&lang=ts"

import "./storeSettings.vue?vue&type=style&index=0&id=2d2b4f6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2b4f6d"]])

export default __exports__